// extracted by mini-css-extract-plugin
var _1 = "fcEvc";
export { _1 as "dot" }
